export const Bio = {
  name: "Mohamed Ali Zbaira",
  roles: [
    "Front-End Developer",
    "Full Stack Developer",
    "Software Engineer",
  ],
  description:
    "Full-Stack Web Developer with a strong background in Angular, React.js, Node.js, and Laravel, and hands-on experience with Docker. Passionate about automation, cloud infrastructure, and modern development workflows, I aim to build secure, scalable, and efficient digital solutions while continuously enhancing my skills in DevOps and web technologies.",
  github: "https://github.com/Mohamed-Ali-Zbaira",
  resume:
    "https://drive.google.com/file/d/1v22hZ1ChjvTMgm40px8hMm2bkTcdjr1m/view?usp=sharing",
  linkedin: "https://www.linkedin.com/in/mohamed-ali-zbaira",
  github: "https://github.com/Mohamed-Ali-Zbaira",
  twitter: "https://twitter.com/med_ali_zbaira?t=D3tRy5_pztxqalCdkcyVLw&s=09",
  insta: "https://instagram.com/mohamed_ali_zbaira",
  facebook: "https://www.facebook.com/profile.php?id=100028475258661",
};

export const skills = [
  {
    title: "Frontend",
    skills: [
      {
        name: "React Js",
        image:
          "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9Ii0xMS41IC0xMC4yMzE3NCAyMyAyMC40NjM0OCI+CiAgPHRpdGxlPlJlYWN0IExvZ288L3RpdGxlPgogIDxjaXJjbGUgY3g9IjAiIGN5PSIwIiByPSIyLjA1IiBmaWxsPSIjNjFkYWZiIi8+CiAgPGcgc3Ryb2tlPSIjNjFkYWZiIiBzdHJva2Utd2lkdGg9IjEiIGZpbGw9Im5vbmUiPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIi8+CiAgICA8ZWxsaXBzZSByeD0iMTEiIHJ5PSI0LjIiIHRyYW5zZm9ybT0icm90YXRlKDYwKSIvPgogICAgPGVsbGlwc2Ugcng9IjExIiByeT0iNC4yIiB0cmFuc2Zvcm09InJvdGF0ZSgxMjApIi8+CiAgPC9nPgo8L3N2Zz4K",
      },
      {
        name: "Angular",
        image:
          "https://cdn4.iconfinder.com/data/icons/logos-and-brands/512/21_Angular_logo_logos-512.png",
      },
      {
        name: "Next Js",
        image:
          "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACAAAAAgCAYAAABzenr0AAACTklEQVR4Ab1XAaQqURB9DyohSykREpRIQSAlBCoECKUFCSRCBBEAaSEABQEoCIEASCwAUICALgCo83do0//9v819XX845O7VnDkzOzP7JWGaBd3C3IJpQVjAHeJ+Rs9a97vKLGrBsB1KgMhEP3FMUUwt4ENMfxr1yQIU4SSjRkbeOZtERmHk6pXQVDlnkHh9S+QLTm1hkiz4n/gzFQuny9FoFLquE+i34x+n02k0m00UCoV3BIzn3MMJrVYLtp1OJ0cS/X4f5/MZhmG8IyDsWtDfEaDIn2232/3zbrvdxuFwwGg04qRBt+VnETBNE0IIkE2n07/erdfrWK/X6Ha73Hb9ZXII3G43ivy3dNRqtZe7lUoFs9mM6oBDwCQCgquALT1FT3a5XF7qIZ/PYzgcolqtcggIIgBZAgRKB6lCRalp2uM8k8mAVMrlchwC+DEBipycE4n5fP44j8ViKJVKSCaTbAJCpgaez4vFIsjoWa/XA50FAgEkEgmEw2F2CkxZBZ5Br5tt1ITcbjd8Ph88Hg+7CBefECCsVitS4aVJcV9D/VMCVITk/Hq9YrPZyBBo2a1YMGvAcQYcj0cCtWMugcdYNhjDiBrP25mx3++x3W6RzWZZ8isfxzQLlsslJpMJpYY5jhkqcOH1ejEYDDAej9FoNOByuZxGsfqVzC7KTqcDSkkqleKsZOqX0mAwiHK5DGrJfr+fs5SqX8sjkQji8ThCoRC+v78Za7l6JagrUh3YkUuZpqgwDaecc9VYSDoV5Fg+at7n+eLN57kuE/EvzHr/Kvs31aYAAAAASUVORK5CYII=",
      },
      {
        name: "HTML",
        image: "https://www.w3.org/html/logo/badge/html5-badge-h-solo.png",
      },
      {
        name: "CSS",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/d/d5/CSS3_logo_and_wordmark.svg/1452px-CSS3_logo_and_wordmark.svg.png",
      },
      {
        name: "JavaScript",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/6/6a/JavaScript-logo.png/800px-JavaScript-logo.png",
      },
      {
        name: "Bootstrap",
        image:
          "https://getbootstrap.com/docs/5.3/assets/brand/bootstrap-logo-shadow.png",
      },
      {
        name: "Css Tailwind",
        image:
          "https://cdn2.iconfinder.com/data/icons/boxicons-logos/24/bxl-tailwind-css-512.png",
      },
    ],
  },
  {
    title: "Backend",
    skills: [
      {
        name: "Node Js",
        image: "https://nodejs.org/static/images/logo.svg",
      },
      {
        name: "Express Js",
        image:
          "data:image/png;base64,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",
      },
      {
        name: "MySQL",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mysql/mysql-original-wordmark.svg",
      },
      {
        name: "MongoDB",
        image:
          "https://raw.githubusercontent.com/devicons/devicon/master/icons/mongodb/mongodb-original-wordmark.svg",
      },
      {
        name: "Firebase",
        image: "https://www.vectorlogo.zone/logos/firebase/firebase-icon.svg",
      },
      {
        name: "Laravel",
        image: "https://www.vectorlogo.zone/logos/laravel/laravel-ar21.svg",
      },
    ],
  },

  {
    title: "Others",
    skills: [
      {
        name: "Git",
        image:
          "https://www.vectorlogo.zone/logos/git-scm/git-scm-ar21.svg",
      },
      {
        name: "GitHub",
        image:
          "https://github.githubassets.com/images/modules/logos_page/GitHub-Mark.png",
      },
      {
        name: "Android Studio",
        image:
          "https://developer.android.com/static/studio/images/new-studio-logo-1_1920.png",
      },
      {
        name: "Netlify",
        image:
          "https://seeklogo.com/images/N/netlify-logo-BD8F8A77E2-seeklogo.com.png",
      },
      {
        name: "Vercel",
        image:
          "https://www.vectorlogo.zone/logos/vercel/vercel-ar21.svg",
      },
      {
        name: "VS Code",
        image:
          "https://upload.wikimedia.org/wikipedia/commons/thumb/9/9a/Visual_Studio_Code_1.35_icon.svg/512px-Visual_Studio_Code_1.35_icon.svg.png?20210804221519",
      },
      {
        name: "Postman",
        image:
          "https://www.vectorlogo.zone/logos/getpostman/getpostman-ar21.svg",
      },
    ],
  },
];

export const experiences = [
  {
    id: 4,
    img: "https://thumbs.dreamstime.com/z/logo-vectoriel-pour-freelance-et-travail-%C3%A0-distance-ind%C3%A9pendant-179625284.jpg?ct=jpeg", // URL d'image générique ou à remplacer
    role: "Web Developer (Freelance)",
    company: "Freelance",
    date: "Apr 2025 | Remote", //
    desc: "Worked on two web applications: a logistics dashboard for shipment tracking and a secure e-learning platform. Created CI/CD pipelines with GitHub Actions for automated deployment.",
    skills: [
      "React.js",
      "Tailwind CSS",
      "GitHub Actions",
      "CI/CD"
    ]
  },
  {
    id: 3,
    img: "https://thumbs.dreamstime.com/z/logo-vectoriel-pour-freelance-et-travail-%C3%A0-distance-ind%C3%A9pendant-179625284.jpg?ct=jpeg", // URL d'image générique ou à remplacer
    role: "Fullstack Web Developer & Junior DevOps (Freelance)",
    company: "Freelance",
    date: "Nov 2024 - Mar 2025 · 5 months", //
    desc: "Designed and deployed a fullstack web platform for hotel room booking, client management, and internal operations. Containerized the application and managed VPS deployment.",
    skills: [
      "Laravel",
      "React.js",
      "MySQL",
      "Docker",
      "Docker Compose",
      "RESTful API"
    ]
  },
  {
    id: 2,
    img: "https://doxso-technologies.com/images/icons/logo.png", // URL d'image générique ou à remplacer
    role: "Web Developer Intern",
    company: "Doxso Technologies",
    date: "Jan 2024 - Jun 2024 · 6 months", //
    desc: "Led the development of the innovative medical platform, Aloo Doctoor, designed to enhance patient data management and facilitate communication among healthcare professionals.",
    skills: [
      "HTML5",
      "CSS",
      "JavaScript",
      "PHP",
      "Laravel",
      "MySQL",
      "XAMPP"
    ]
  },
  {
    id: 0,
    img: "https://res.cloudinary.com/dkrfmqbj1/image/upload/v1697759250/Portfolio/eigoqjgavknxr2nswm7b.png",
    role: "Web Developer Intern",
    company: "Exadev",
    date: "Jan 2023 - Feb 2023 · 2 months", // Mise à jour pour correspondre au CV
    desc: "I created an E-commerce website as part of my second-year internship. The project's objective was to apply the skills I had acquired during my web development studies and to create a functional and professional E-commerce platform.",
    skills: [
      "HTML5",
      "CSS",
      "PHP",
      "Laravel",
      "XAMPP",
      "Databases",
      "MySQL"
    ]
  },
  {
    id: 1,
    img: "https://res.cloudinary.com/dkrfmqbj1/image/upload/v1697759250/Portfolio/tk6p7fcltayjqfdruayw.png",
    role: "Web Development Intern",
    company: "UIB - Société Générale Group",
    date: "Jan 2022 - Feb 2022 · 2 months", // Mise à jour pour correspondre au CV
    desc: "I created my portfolio using HTML, CSS, and JavaScript to showcase my skills and achievements. Explore my work and feel free to contact me for exciting collaborations in the field of web development.",
    skills: [
      "HTML5",
      " CSS",
      "JavaScript",
      "jQuery",
      "React", // Ajouté car mentionné dans le CV
    ]
  }
];

export const education = [
  {
    id: 3,
    img: "https://res.cloudinary.com/dkrfmqbj1/image/upload/v1697570771/Portfolio/vy5lhqz6ct7obadir4b0.png",
    school: "Higher Institute of Technological Studies of Sfax (ISET Sfax)",
    date: "September 2022 - June 2024", // Mise à jour pour couvrir le diplôme de Bachelor
    degree: "Bachelor's Degree in Information Technology", // Remplacé par le diplôme final
    desc: "Completed the second year with specialization in Computer System Development and obtained the Bachelor's Degree in Information Technology."
  },
  {
    id: 2,
    img: "https://res.cloudinary.com/dkrfmqbj1/image/upload/v1697570790/Portfolio/bk4ljbztlulahsnu3jwv.jpg",
    school: "Higher Institute of Technological Studies of Mednine (ISET Mednine)",
    date: "September 2021 - June 2022",
    degree: "First Year in Computer Science",
    desc: "Completed the first year with admission to the main section and chose the specialization in Computer System Development."
  },
  {
    id: 1,
    img: "https://res.cloudinary.com/dkrfmqbj1/image/upload/v1697570823/Portfolio/abj9nqzcbwawdffjndnn.webp",
    school: "Ali Bourguiba High School, Mahres",
    date: "2017 - 2021", // Mise à jour pour correspondre au CV
    Niveau: "High School Diploma (Baccalauréat)",
    degree: "Technical Stream (Bac Technique)",
    desc: "I successfully completed my high school education and was admitted to the next level."
  }
];
export const projects = [
 
  {
    id: 3,
    title: "Aloo Doctoor (Medical Platform Internship)",
    date: "01/2024 – 06/2024 | Sfax", // [cite: 28]
    description: "Led the development of 'Aloo Doctoor,' an innovative medical platform to enhance patient data management and communication among healthcare professionals, focusing on security and scalability.", // [cite: 29, 32, 33]
    image: "https://camo.githubusercontent.com/ad2c3d08d3ed67a9e83da2e2b7be46696ca61b615543cffc60c7db834bb026aa/68747470733a2f2f7265732e636c6f7564696e6172792e636f6d2f646b72666d71626a312f696d6167652f75706c6f61642f76313733303833363834362f474954253230446576656c6f706d656e742532306f66253230612532304d65646963616c253230506c6174666f726d2f73637265656e636170747572652d3132372d302d302d312d383030302d323032342d31312d30352d32305f35385f33355f7670756c61392e706e67", // Placeholder à remplacer
    tags: ["HTML5", "CSS", "JavaScript", "PHP", "Laravel", "MySQL", "XAMPP"], // [cite: 31, 32, 33, 34]
    category: "fullstack",
    github: "https://github.com/Mohamed-Ali-Zbaira/AlooDoctoor-Development-of-a-Medical-Platform", // [cite: 35]
    webapp: "https://github.com/Mohamed-Ali-Zbaira/AlooDoctoor-Development-of-a-Medical-Platform",
  },
 

  // PROJETS PRÉ-EXISTANTS MAINTENUS ET AJUSTÉS
  {
    id: 9,
    title: "E-commerce (Internship Exadev)",
    date: "01/2023 – 02/2023 | Sfax", // Mise à jour pour correspondre au CV [cite: 37]
    description:
      "My E-commerce project, carried out during my second-year internship, aims to put into practice the skills acquired during my web development studies and create a functional and professional E-commerce platform.",
    image:
      "https://res.cloudinary.com/dkrfmqbj1/image/upload/v1697286997/Project%20Laravel/Client/xkusejtebudbbdqdlxy5.png",
    tags: [
      "HTML",
      "CSS",
      "JAVASCRIPTS",
      "PHP",
      "LARAVEL",
      "Mysql",
      "XAMPP", // Ajouté car mentionné dans le CV [cite: 42]
    ],
    category: "web app",
    github: "https://github.com/MedAlizbaira/E-commerce",
    webapp: "",
  },
  {
    id: 10, // ID mis à jour
    title: "Reservation-ticket",
    date: "03/2022 – 04/2022 | Sfax",
    description:
      "Online reservation system for sports and film tickets. User and ticket management, authentication, and administrator dashboard.",
    image:
      "https://res.cloudinary.com/dkrfmqbj1/image/upload/v1705695864/Reservation-ticket/screencapture-127-0-0-1-3000-2023-12-13-16_27_53_ghqbi0.png",
    tags: [
      "HTML",
      "CSS",
      "Css Tailwind",
      "JAVASCRIPTS",
      "Next Js",
      "Express Js",
      "MongoDB",
    ],
    category: "web app",
    github: "https://github.com/Mohamed-Ali-Zbaira/Reservation-ticket",
    webapp: "",
  },
  {
    id: 11, // ID mis à jour
    title: "RendezvousHub",
    date: "04/2022 – 04/2022 | Sfax",
    description:
      "Optimize your appointment management with RendezVousPro. Create, edit, and track your appointments with ease. Never miss a crucial meeting again thanks to our efficient application.",
    image:
      "https://res.cloudinary.com/dkrfmqbj1/image/upload/v1697803976/RendezvousHub/uerpztgt2q1xfesg3hok.png",
    tags: [
      "HTML",
      "CSS",
      "JAVASCRIPTS",
      "bootstrap",
      "React",
    ],
    category: "web app",
    github: "https://github.com/MedAlizbaira/RendezvousHub",
    webapp: "https://rendezvous-hub.vercel.app/",
  },
  {
    id: 12, // ID mis à jour
    title: "ArtyProd",
    date: "04/2022 – 05/2022 | Sfax",
    description:
      "ArtyProd, a graphic design, audiovisual production, and 3D design agency, aims to create a web application to showcase its services to users. The application allows users to explore the agency's portfolio, learn about its services, view team members, and contact the agency.",
    image:
      "https://res.cloudinary.com/dkrfmqbj1/image/upload/v1699703187/Artyprod/g66ojzncm9hdr1yufddb.png",
    tags: [
      "HTML",
      "CSS",
      "JAVASCRIPTS",
      "CSS Tailwind",
      "Django",
    ],
    category: "web app",
    github: "https://github.com/MedAlizbaira/ArtyProd",
    webapp: "https://github.com/MedAlizbaira/ArtyProd",
  },
  {
    id: 13, // ID mis à jour
    title: "Commerce Électronique",
    date: "04/2022 – 05/2022 | Sfax",
    description:
      "Ce projet est un site de commerce électronique spécialisé dans la vente en ligne de légumes et de fruits. Les clients peuvent parcourir une large gamme de produits frais",
    image:
      "https://res.cloudinary.com/dkrfmqbj1/image/upload/v1699736780/Commerce-electronique/betgj62f17okgmhnukdn.png",
    tags: [
      "HTML",
      "CSS",
      "JAVASCRIPTS",
      "bootstrap",
      "Django",
    ],
    category: "web app",
    github: "https://github.com/MedAlizbaira/Commerce-electronique",
    webapp: "https://github.com/MedAlizbaira/Commerce-electronique",
  },
  {
    id: 14, // ID mis à jour
    title: "InvoiceSwiftAngular",
    date: "09/2023 – 09/2023 | Sfax",
    description:
      "About Angular-powered invoicing app: Seamlessly manage invoices with client selection, item details, and real-time total calculations. Leverages Angular's two-way data binding and modular components for a dynamic and user-friendly experience. Ideal for showcasing modern web development principles",
    image:
      "https://res.cloudinary.com/dkrfmqbj1/image/upload/v1699717285/Angular-Invoice-Manager/j5ju34lrbi6bc3a4sji3.png",
    tags: [
      "HTML",
      "CSS",
      "JAVASCRIPTS",
      "bootstrap",
      "Angular",
    ],
    category: "web app",
    github: "https://github.com/MedAlizbaira/InvoiceSwiftAngular",
    webapp: "https://invoiceswift-angular.vercel.app/",
  },
  {
    id: 15, // ID mis à jour
    title: "North Africa's Tunisia Diamond",
    date: "10/2023 – 11/2023 | Sfax",
    description:
      "North Africa's Tunisia Diamond: Manages hotels, users; features include CRUD operations for hotels, user registration, login",
    image:
      "https://res.cloudinary.com/dkrfmqbj1/image/upload/v1705695174/North%20Africa%27s%20Tunisia%20Diamond/Capture_d_%C3%A9cran_2024-01-19_211205_utxikw.png",
    tags: ["HTML",
      "CSS",
      "JAVASCRIPTS",
      "Express Js",
      "Angular",],
    category: "web app",
    github: "https://github.com/Mohamed-Ali-Zbaira/North-Africa-s-Tunisia-Diamond___front-end",
    webapp: "",
  },
  {
    id: 16, // ID mis à jour
    title: "Client and Invoice Management ",
    date: "11/2023 – 12/2023 | Sfax",
    description:
      "Client and invoice management system. Efficient, activation, address-based tracking, statistics. Database, UI design, data analysis proficiency demonstrated",
    image:
      "https://res.cloudinary.com/dkrfmqbj1/image/upload/v1705697987/mp-fe-Mohamed-Ali-Zbaira/386870827_261514060272079_7432626746948972750_n_sibbau.png",
    tags: ["HTML",
      "CSS",
      "JAVASCRIPTS",
      "Spring Boot",
      "Angular",],
    category: "web app",
    github: "https://github.com/Mohamed-Ali-Zbaira/mp-fe-Mohamed-Ali-Zbaira",
    webapp: "",
  },
];
